import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { navItems } from '../data/profile';
export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const linkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `whitespace-nowrap font-sans text-[13px] transition-colors duration-150 ease-out ${isActive ? 'text-emerald' : 'text-navy-600 hover:text-navy'}`;
  return <header className="fixed inset-x-0 top-0 z-50 bg-parchment/95 backdrop-blur" data-id="element-49" data-mp="qwnf08mhnr34">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-50" data-mp="qyqgppx078no">
        <div className="flex h-20 items-center justify-between gap-8" data-id="element-51" data-mp="14xg9wugpco6r">
          <Link to="/" className="flex items-center gap-3" onClick={() => setMenuOpen(false)} data-id="element-52" data-mp="zxlo35bsaosk">
            <span className="flex h-11 w-11 items-center justify-center rounded-t-2xl bg-emerald font-display text-sm text-white" data-id="element-53" data-mp="2gbbrsayzrb1o">
              SD
            </span>
            <span className="hidden leading-tight sm:block" data-id="element-54" data-mp="2belajkbga9eo">
              <span className="block font-display text-[17px] text-navy" data-id="element-55" data-mp="29isdluxx6lpx">Samanntha DuBridge</span>
              <span className="block font-sans text-[10px] uppercase tracking-overline text-navy-400" data-id="element-56" data-mp="2ehvjtipmyxzh">
                Executive Dossier
              </span>
            </span>
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-5 lg:flex" data-id="element-57" data-mp="2og1i7qc8hlzl">
            {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={linkClass} data-id="element-58" data-mp="1quvs6uw5my9p">
                {item.label}
              </NavLink>)}
            <NavLink to="/inquire" className="whitespace-nowrap bg-navy px-5 py-2.5 font-sans text-[13px] font-medium text-white transition-colors duration-150 ease-out hover:bg-emerald" data-id="element-59" data-mp="20qytxzn3guw4">
              Inquire
            </NavLink>
          </nav>

          <button type="button" onClick={() => setMenuOpen(open => !open)} aria-expanded={menuOpen} aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'} className="inline-flex h-11 w-11 items-center justify-center text-navy lg:hidden" data-id="element-60" data-mp="1d1nv4npb1akm">
            {menuOpen ? <XIcon className="h-5 w-5" data-id="element-61" data-mp="1eqhyvy7k32qg" /> : <MenuIcon className="h-5 w-5" data-id="element-62" data-mp="1esvtk5ybqcxh" />}
          </button>
        </div>
      </div>

      {menuOpen && <div className="bg-parchment-light lg:hidden" data-id="element-63" data-mp="m2dstbl2onn8">
          <nav aria-label="Mobile" className="mx-auto max-w-dossier px-6 py-4" data-id="element-64" data-mp="m2vw2s65k24n">
            <ul className="space-y-1" data-id="element-65" data-mp="h4c7sl436e94">
              {[...navItems, {
            label: 'Inquire',
            to: '/inquire'
          }].map(item => <li key={item.to} data-id="element-66" data-mp="w1uvrl8xwnfi">
                  <NavLink to={item.to} end={item.to === '/'} onClick={() => setMenuOpen(false)} className={({
              isActive
            }) => `block py-2.5 font-sans text-sm transition-colors duration-150 ease-out ${isActive ? 'text-emerald' : 'text-navy-600'}`} data-id="element-67" data-mp="r1gmy0zil9gf">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
          </nav>
        </div>}
    </header>;
}